import 'react-app-polyfill/ie11';
import React,{ Suspense } from 'react';
import ReactDOM from 'react-dom';
import PilotApp from './PilotApp';

//import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import { createRoot } from 'react-dom/client';
import { keycloak,KeycloakService} from './service/KeyCloakService';
import axios from 'axios';
import './i18n';
import { PrimeReactProvider } from 'primereact/api';

const root = createRoot(document.getElementById('root'));

KeycloakService.init().then((authenticated)=>{
    if (authenticated) {
        console.log('User is authenticated:'+keycloak.token);
    root.render(
        <HashRouter>
            <ScrollToTop>
                <PrimeReactProvider><PilotApp></PilotApp></PrimeReactProvider>                                
            </ScrollToTop>
        </HashRouter>
    );
    } 
    else {
        console.log('User is not authenticated');
    }
    }
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();